import React from 'react';

const ProgressScoreOverview = ({
  score,
  correctAnswers,
  totalScorableAnswers,
}) => {
  const niceScore = (score * 100).toFixed(2);

  return (
    <div>
      <header>
        <h4>{t('progress.score.overview')}</h4>
      </header>
      <table className="DataTable Table score">
        <tbody>
          <tr>
            <td className="DataTable-name wide score-header">
              {t('progress.score.title')}
            </td>
            <td>{niceScore}%</td>
          </tr>
          <tr>
            <td className="DataTable-name wide score-metadata">
              {t('progress.score.number_correct')}
            </td>
            <td>
              {correctAnswers} / {totalScorableAnswers}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProgressScoreOverview;
